export const keyFieldTileBaseSx = {
  bgcolor: 'background.default',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 2,
  p: 2,
  minHeight: 84,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
} as const;

export const keyFieldTileLabelSx = {
  fontSize: '0.625rem',
  fontWeight: 700,
  letterSpacing: '1px',
  textTransform: 'uppercase',
  color: 'text.disabled',
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  mb: 1.25,
} as const;
